import "./VehicleListElement.less";
import { LocationStore, VehicleLocation } from './LocationStore';
import { shortDateTime } from 'Library/Formatting';
import { DeliveryInfoActivator } from "Feature/Deliveries/DeliveryInfoActivator";

export class VehicleListElement extends HTMLElement {
    static tag = "vehicle-list";
    private _vehicles: { [key: string]: VehicleLocation } = {}; 
    private _previousVehicles: { [x: string]: VehicleLocation; } = {};
    
    connectedCallback() { 
        this.refresh();
        this.addEventListener("click", this.clickHandler);
        LocationStore.instance.addEventListener("source-updated", this.sourceHandler);
    }

    disconnectedCallback() { 
        this.removeEventListener("click", this.clickHandler);
    }

    private sourceHandler = (event: CustomEvent<VehicleLocation>) => {
        const location = event.detail;
        this._vehicles[location.deviceId] = location;
        this.refresh();
    }

    private refresh_old = () => { 
        const vehicles = Object.values(this._vehicles);

        vehicles.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });
            
        this.innerHTML = this.view(vehicles);
    }

    private refresh = () => {
        const vehicles = Object.values(this._vehicles);

        // Check if the current vehicles are different from the previous ones
        if (JSON.stringify(this._previousVehicles) !== JSON.stringify(vehicles)) {
            this._previousVehicles = { ...this._vehicles }; // Update the stored state
            vehicles.sort((a, b) => a.name.localeCompare(b.name));

            this.innerHTML = this.view(vehicles);
        }
    };

    private clickHandler = (event: MouseEvent) => { 
        if (this.hasAttribute("expanded")) { 
            if (event.target instanceof Element) { 

                const button = event.target.closest("button[route-name]");

                if (button) { 
                    DeliveryInfoActivator.show(button.getAttribute("route-name"));
                    return;
                }

                const li = event.target.closest("li");
                if (li) { 
                    const deviceid = li.getAttribute("id");
                    this.dispatchEvent(new CustomEvent("vehicle-selected", { detail: deviceid }));
                }
            }
            return;
        }
            
        this.toggleAttribute("expanded", true)
        requestAnimationFrame(() => { 
            document.addEventListener("click", this.documentClickHandler);
        });
        
    };

    private close = () => { 
        this.removeAttribute("expanded");
        document.removeEventListener("click", this.documentClickHandler);
    }

    private documentClickHandler = (event: MouseEvent) => { 
        if (event.target instanceof HTMLElement) {
            if (event.target.closest("vehicle-list") && !event.target.closest("button"))    
                return;
            
               
            
            this.close();
        }
    }

     private view = (vehicles: VehicleLocation[]) => `
        <button id="cars">${vehicles.length || "Ingen"} Bil${vehicles.length === 1 ? "" : "er"}</button>
        <ul>
            ${vehicles.map(vehicle => `
                <li id="${vehicle.deviceId}">
                    <div class=icon>
                        <div style="background-color:${LocationStore.routeToColor(vehicle.name)}"></div>
                    </div>
                    <div class=name>${vehicle.name}</div>
                    <div class=initials>${vehicle.initials}</div>
                    <div class=phone-number>${vehicle.phoneNumber}</div>
                    <div class=date>${shortDateTime(new Date(vehicle.created))}</div>
                    <button type=button route-name="${vehicle.name}">
                        ${require("./Images/smartphone.svg")}
                    </button>
                </li>
            `).join("")}
        </ul>
    `;
}

customElements.define(VehicleListElement.tag, VehicleListElement);